import { useState } from "react";
import { useInstallPrompt } from "../lib/installPrompt";
import { readPref, writePref } from "../lib/prefs";

/**
 * "Install the app" card on the hub. Shown only when installing is possible and hidden once installed or dismissed:
 * asking again on every open is nagging.
 */
export function InstallCard() {
  const { canPrompt, needsManualSteps, installed, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => readPref("install.dismissed") === "1");
  const [showSteps, setShowSteps] = useState(false);

  if (installed || dismissed || (!canPrompt && !needsManualSteps)) return null;

  const dismiss = () => {
    writePref("install.dismissed", "1");
    setDismissed(true);
  };

  return (
    <div className="my-3 flex flex-col gap-2 rounded-[var(--radius-card)] border border-border bg-surface p-4 print:hidden">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-[14px] font-bold">Install the Readiness Engine</div>
          <div className="text-[13px] text-text-muted">
            Open it from your home screen. Drafts you write offline are saved and sent when you're
            back online.
          </div>
        </div>
        <button
          type="button"
          aria-label="Dismiss install"
          onClick={dismiss}
          className="text-[14px] text-text-muted"
        >
          ✕
        </button>
      </div>
      {canPrompt ? (
        <button
          type="button"
          onClick={() => void install()}
          className="min-h-10 rounded-[var(--radius-control)] border-[1.5px] border-accent bg-accent-tint px-3 text-[13px] font-bold text-accent"
        >
          Install app
        </button>
      ) : showSteps ? (
        <p className="m-0 text-[13px]">
          Tap the Share button in Safari, then <strong>Add to Home Screen</strong>.
        </p>
      ) : (
        <button
          type="button"
          onClick={() => setShowSteps(true)}
          className="min-h-10 rounded-[var(--radius-control)] border-[1.5px] border-accent bg-accent-tint px-3 text-[13px] font-bold text-accent"
        >
          How to install
        </button>
      )}
    </div>
  );
}
